import React from 'react';

import { ArrayField, useRecordContext } from 'react-admin';

import { get } from 'react-hook-form';

import ArrayDiffFieldLayout from './ArrayDiffFieldLayout';

const ArrayDiffField = ({
  source,
  label,
  children,
  size,
  width,
}: {
  source: string;
  label: string;
  children?: React.ReactNode;
  size?: {
    xs?: number;
    md?: number;
    xl?: number;
  };
  width?: string;
}) => {
  const record = useRecordContext();

  const arrayValues = get(record, source, []);
  const isItemRemoved = (arrayValues?.oldValue?.length ?? 0) > 0;
  const isItemAdded = (arrayValues?.newValue?.length ?? 0) > 0;

  return (
    <ArrayDiffFieldLayout
      label={label}
      size={size}
      width={width}
      removedElement={isItemRemoved && (
        <ArrayField sortable={false} source={`${source}.oldValue`}>
          {children}
        </ArrayField>
      )}
      addedElement={isItemAdded && (
        <ArrayField sortable={false} source={`${source}.newValue`}>
          {children}
        </ArrayField>
      )}
    />
  );
};

export default ArrayDiffField;
